import { render, staticRenderFns } from "./devicesDashboardForm.vue?vue&type=template&id=4b036b50&scoped=true"
import script from "./devicesDashboardForm.vue?vue&type=script&lang=js"
export * from "./devicesDashboardForm.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardForm.vue?vue&type=style&index=0&id=4b036b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b036b50",
  null
  
)

export default component.exports